<div class="item">
  <div class="image-container">
    <a [routerLink]="item.product.url" tabindex="-1">
      @if (item.product.images?.length) {
        <cx-media [container]="item.product.images"></cx-media>
      } @else {
        <img class="no-img" src="assets/images/product-photo-missing.svg" alt="" />
      }
    </a>
  </div>

  <div class="info">
    <!--Status -->
    <div class="status" *ngIf="item.status">
      <div class="value" [ngClass]="item.status.code || 'PROCESSING'">
        {{ item.status.name }}
      </div>
    </div>

    <div *ngIf="item.product.name" class="name">
      <a class="link" [routerLink]="item.product.url">{{ item.product.dealType }} {{ item.product.name }}</a>
    </div>

    <div *ngIf="item.product.code" class="code">Код: {{ item.product.code }}</div>
  </div>

  <div class="status-desk" *ngIf="item.status">
    <div class="value" [ngClass]="item.status.code || 'PROCESSING'">
      {{ item.status.name }}
    </div>
  </div>

  <div class="data">
    <!-- Item Price -->
    <div class="weight-volume">
      <ng-container *ngIf="item.weight">
        <div class="weight">{{ item.weight }} кг</div>
      </ng-container>
    </div>

    <!-- Total -->
    <div class="total">
      <div *ngIf="item.totalPrice">
        <div class="value" *ngIf="!isGifted; else giftTotal">{{ item.totalPrice.formattedValue }}</div>
      </div>
      <ng-template #giftTotal>
        <div class="gift">Подарок</div>
      </ng-template>
    </div>

    <!-- Item Quantity -->
    <div class="quantity">{{ item.quantity }} {{ item.saleUnit?.name }}</div>
  </div>

  <div *ngIf="item.basePrice && !isGifted" class="price">
    <div *ngIf="item.basePrice" class="value">{{ item.basePrice?.formattedValue }} / {{ item.saleUnit?.name }}</div>
  </div>
</div>
